export function ImportPage() {
  return (
    <div className="p-4">
      <h1 className="text-xl font-bold text-[var(--color-text-primary)] mb-4">Import Trades</h1>
      <div className="text-[var(--color-text-muted)] text-center py-12">
        <p className="text-lg mb-2">Data import coming soon</p>
        <p className="text-sm">Import your existing trades from CSV or JSON files</p>
      </div>
    </div>
  )
}
